<div class="tw:relative tw:flex tw:min-h-screen tw:items-center tw:justify-center tw:p-4 tw:sm:p-8">
  <div
    class="tw:dark:opacity-20 tw:pointer-events-none tw:absolute tw:inset-0 tw:bg-[linear-gradient(to_right,var(--p-content-border-color)_1px,transparent_1px),linear-gradient(to_bottom,var(--p-content-border-color)_1px,transparent_1px)] tw:bg-[length:10rem_10rem] tw:[mask-image:radial-gradient(ellipse_100%_75%_at_50%_0%,black_0%,transparent_80%)]"></div>
  <main
    class="card tw:relative tw:z-10 tw:grid tw:w-full tw:max-w-5xl tw:overflow-hidden tw:rounded-2xl tw:border tw:border-surface tw:shadow-md tw:md:grid-cols-[0.9fr_1.1fr]">
    <div
      class="tw:absolute tw:right-6 tw:top-6 tw:z-20 tw:flex tw:max-w-[calc(100%-3rem)] tw:items-center tw:gap-2 tw:rounded-full tw:border tw:border-surface tw:bg-surface tw:px-3 tw:py-2 tw:text-sm tw:shadow-sm"
      tooltipPosition="bottom"
      [pTooltip]="`Logged in as: ${currentUser().visibleName}\nEmail: ${currentUser().email}`">
      <span class="tw:shrink-0 tw:text-muted-color">Logged in as:</span>
      <i class="pi pi-user tw:shrink-0 tw:text-muted-color"></i>
      <span class="tw:truncate tw:font-medium tw:text-color">
        {{ currentUser().visibleName || currentUser().name }}
      </span>
    </div>
    <section class="tw:hidden tw:flex-col tw:justify-between tw:bg-emphasis tw:p-10 tw:md:flex">
      <img
        class="tw:w-40"
        [src]="
          themeService.isDark()
            ? 'assets/images/brand/logo-light.svg'
            : 'assets/images/brand/logo-dark.svg'
        "
        [alt]="appConfig().name || 'GenGuardX'" />
      <div>
        <span
          class="tw:flex tw:h-12 tw:w-12 tw:items-center tw:justify-center tw:rounded-full tw:bg-primary tw:text-xl tw:text-primary-contrast">
          <i class="pi pi-shield"></i>
        </span>
        <h2 class="tw:mt-6 tw:text-2xl tw:font-semibold tw:text-color">A secure connection</h2>
        <p class="tw:mt-3 tw:max-w-sm tw:leading-6 tw:text-muted-color">
          Review exactly what an application is requesting before sharing access to your account.
        </p>
      </div>
      <p class="tw:text-sm tw:text-muted-color">
        You can revoke access at any time from your account settings.
      </p>
    </section>

    <section class="tw:flex tw:min-h-[32rem] tw:flex-col tw:justify-center tw:p-7 tw:sm:p-10">
      <div
        class="tw:flex tw:h-11 tw:w-11 tw:items-center tw:justify-center tw:rounded-xl tw:bg-primary/10 tw:text-lg tw:text-primary">
        <i class="pi pi-link"></i>
      </div>
      <p class="tw:mt-6 tw:text-sm tw:font-medium tw:text-muted-color">Connect application</p>
      <h1 class="tw:mt-2 tw:text-3xl tw:font-semibold tw:text-color">
        Authorize {{ clientName() }}
      </h1>
      <p class="tw:mt-3 tw:max-w-xl tw:leading-6 tw:text-muted-color">
        This application is requesting access to your GGX account.
      </p>
      @if (authorizationError(); as error) {
        <div
          class="tw:mt-8 tw:rounded-lg tw:border tw:border-red-200 tw:bg-red-50 tw:p-5 tw:text-red-900"
          role="alert">
          <div class="tw:flex tw:items-start tw:gap-3">
            <i class="pi pi-exclamation-triangle tw:mt-0.5 tw:text-red-600"></i>
            <div class="tw:min-w-0">
              <h2 class="tw:font-semibold">Authorization failed</h2>
              <p class="tw:mt-1 tw:leading-6">{{ error.description }}</p>
              <p class="tw:mt-3 tw:text-sm tw:text-red-800">
                Error code:
                <code class="tw:font-mono">{{ error.code }}</code>
              </p>
            </div>
          </div>
        </div>
      } @else if (scopes().length) {
        <div class="tw:mt-8 tw:border-y tw:border-surface tw:py-5">
          <p class="tw:font-medium tw:text-color">Requested access</p>
          <ul class="tw:mt-3 tw:space-y-3">
            @for (scope of scopes(); track scope) {
              <li class="tw:flex tw:items-center tw:gap-3 tw:text-muted-color">
                <i class="pi pi-check-circle tw:text-primary"></i>
                <span>{{ scope }}</span>
              </li>
            }
          </ul>
        </div>
      }

      @if (!authorizationError()) {
        <div class="tw:mt-8 tw:flex tw:flex-col-reverse tw:gap-3 tw:sm:flex-row tw:sm:justify-end">
          <!-- TODO: Handle deny gracefully in UI -->
          <button
            test-id="oauth-consent-deny"
            pButton
            severity="secondary"
            class="tw:justify-center"
            label="Deny"></button>
          <button
            test-id="oauth-consent-allow-access"
            pButton
            class="tw:justify-center"
            [loading]="isAuthorizing()"
            (click)="onUserConsent()"
            [label]="isAuthorizing() ? 'Redirecting…' : 'Allow Access'"></button>
        </div>
      } @else {
        <div class="tw:mt-8 tw:flex tw:justify-end">
          <button
            test-id="oauth-consent-try-again"
            pButton
            severity="secondary"
            class="tw:justify-center"
            label="Try again"
            (click)="onUserConsent()"></button>
        </div>
      }
    </section>
  </main>
</div>
